import React from 'react';
import _ from 'lodash';
import Input from "antd/lib/input";
import createMapProps from '../Helpers/createMapProps';
import createComponent from "../Helpers/createComponent";

const { TextArea } = Input;

class TextAreaField extends React.PureComponent {

  textAreaRef = React.createRef();
  cursorPos = null;

  componentDidUpdate () {
    if (this.cursorPos !== null) {
      const el = this.textAreaRef.current
        && this.textAreaRef.current.resizableTextArea
        && this.textAreaRef.current.resizableTextArea.textArea;
      if (el) {
        el.selectionStart = this.cursorPos;
        el.selectionEnd = this.cursorPos;
      }
      this.cursorPos = null;
    }
  }

  handleChange = (event) => {
    this.cursorPos = event.target.selectionStart;
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  render () {

    const style = _.merge({}, { width: '100%' }, this.props.style);

    return (

      <TextArea {...this.props} style={style} ref={this.textAreaRef} onChange={this.handleChange} />

    );
  }
}

const mapProps = createMapProps((mappedProps, originalProps) => {

  const {
    onChange: _onChange
  } = mappedProps;

  const onChange = (event) => _onChange(event.nativeEvent.target.value);

  return { ...mappedProps, onChange };

})

TextAreaField =  createComponent(TextAreaField, mapProps);

TextAreaField.defaultProps = {
  style: {}
}

export default TextAreaField;
